import React from 'react';
import { useAuthStore } from '../stores/authStore';

// Import all dashboard components
import ClientDashboard from '../pages/client/Dashboard';
import ConsultantDashboard from '../pages/consultant/Dashboard';
import TrainerDashboard from '../pages/trainer/Dashboard';

const DashboardRouter: React.FC = () => {
  const { user, activeRole } = useAuthStore();

  if (!user || !activeRole) {
    return null;
  }

  // Route to appropriate dashboard based on active role
  switch (activeRole) {
    case 'CONSULTANT':
      return <ConsultantDashboard />;
    
    case 'TRAINER':
      return <TrainerDashboard />;
    
    case 'CLIENT':
    default:
      return <ClientDashboard />;
  }
};

export default DashboardRouter;
